import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';

const baseUrlVideo = "./../assets/video/";

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  host: {class: 'video-modal' }
})
export class VideoModalComponent implements OnInit {
  @Input() url: string;
  @Input() open: boolean;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() urlChange = new EventEmitter<string>();

  get videoUrl(): string {
    return !!this.url ? baseUrlVideo + this.url : null;
  }

  @HostBinding('class') get hostClasses(): string {
		return [
			'video-modal',
			this.open ? 'open' : '',
		].join(' ');
	}

  constructor() { }

  ngOnInit() {
  }

  close() {
    this.open = false;
    this.openChange.emit(this.open);
    this.urlChange.emit(null);
  }

}
